<template>
  <b-form class="form profile-name">
    <div class="w50">
      <b-form-group label="Full Name" label-for="input-1" class="custom-label">
        <b-form-input
          v-model.trim="$v.fullName.$model"
          trim
          class="custom-input"
          :class="{ 'is-invalid': validationStatus($v.fullName) }"
          placeholder="Full Name"
          type="text"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="!$v.fullName.required"
          class="invalid-feedback"
        >
          The name is required
        </b-form-invalid-feedback>
      </b-form-group>
      <div class="overlay" v-if="calendar" @click="calendar = false"></div>
      <div class="form-group birthday_input">
        <b-form-group
            id="icon"
          label="Birthday Date"
          label-for="input-2"
          class="custom-label"
        >
          <b-input-group>
            <b-form-input
                id="birthdate"
                class="custom-input"
                type="date"
                v-model.trim="birthdate"
            >
            </b-form-input>
          </b-input-group>
        </b-form-group>
        <b-form-invalid-feedback v-if="!$v.birthdate" class="invalid-feedback">
          The Birthday Date is required.
        </b-form-invalid-feedback>
        <div class="birthday-calendar_wrapper">
          <b-calendar
            v-if="calendar"
            v-model="birthdate"
            @context="onContext"
            id="birthday_calender"
            :hide-header="true"
            selected-variant="success"
            block
            today-variant="info"
            :date-format-options="{
              year: 'numeric',
              month: 'long',
              day: '2-digit',
              weekday: 'short'
            }"
            locale="en-US"
          ></b-calendar>
        </div>
      </div>
    </div>
    <div class="w50">
      <b-form-group label="Email" label-for="input-3" class="custom-label">
        <b-form-input
          id="input-3"
          v-model.trim="email"
          class="custom-input"
          placeholder="Email"
          type="email"
          :disabled="true"
        >
        </b-form-input>
      </b-form-group>
      <b-form-group
        label="Phone Number"
        label-for="input-4"
        class="custom-label"
      >
        <the-mask
            id="input-4"
            :mask="['(###) ###-####', '##.###.###/####-##']"
            class="custom-input"
            style="width:100%"
            type="tel"
            v-model="phoneNumber"
            placeholder=""
        />

      </b-form-group>
    </div>
    <div class="row">
      <div class="col-md-12">
        <b-form-group
          label="Main Line"
          label-for="input-5"
          class="custom-label"
        >
          <b-form-input
            id="input-5"
            v-model.trim="mainline"
            trim
            class="custom-input"
            placeholder="What’s your Main Line?"
            type="text"
          >
          </b-form-input>
        </b-form-group>
      </div>
    </div>
    <template>
      <div class="row">
        <div class="col-md-12">
          <h2 class="specific">
            MORE DETAILS
            <span
              v-b-tooltip="
                `Collecting additional user details like timezone, political affiliation, religion, language, and location can greatly enhance the quality of your experience and interactions on our platform.`
              "
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.00001 12.0003C8.3682 12.0003 8.66668 11.7018 8.66668 11.3337C8.66668 10.9655 8.3682 10.667 8.00001 10.667C7.63182 10.667 7.33334 10.9655 7.33334 11.3337C7.33334 11.7018 7.63182 12.0003 8.00001 12.0003Z"
                  fill="#B3C2CB"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.23738 5.70689C7.91366 5.7211 7.74104 5.85135 7.68129 5.97831C7.5245 6.31145 7.12733 6.45441 6.79419 6.29762C6.46106 6.14083 6.3181 5.74366 6.47489 5.41053C6.82301 4.67086 7.57297 4.40144 8.17892 4.37484C8.7618 4.34926 9.48718 4.53492 9.88849 5.05823C10.1973 5.46093 10.3708 5.9714 10.3007 6.50813C10.2297 7.05237 9.91926 7.54056 9.41556 7.91111C8.74294 8.40594 8.74413 8.65841 8.74431 8.69517C8.74431 8.69571 8.74431 8.6962 8.74431 8.69664C8.74431 9.06483 8.44583 9.36331 8.07764 9.36331C7.70945 9.36331 7.41098 9.06483 7.41098 8.69664C7.41098 8.05884 7.78196 7.45763 8.62545 6.8371C8.88471 6.64637 8.96187 6.46388 8.97862 6.33555C8.99635 6.19971 8.95784 6.03573 8.83044 5.8696C8.82148 5.85791 8.77279 5.80928 8.65086 5.76547C8.53445 5.72363 8.38807 5.70028 8.23738 5.70689Z"
                  fill="#B3C2CB"
                />
                <path
                  d="M8 15.3337C3.93334 15.3337 0.666672 12.067 0.666672 8.00033C0.666672 3.93366 3.93334 0.666992 8 0.666992C12.0667 0.666992 15.3333 3.93366 15.3333 8.00033C15.3333 12.067 12.0667 15.3337 8 15.3337ZM8 2.00033C4.66667 2.00033 2.00001 4.66699 2.00001 8.00033C2.00001 11.3337 4.66667 14.0003 8 14.0003C11.3333 14.0003 14 11.3337 14 8.00033C14 4.66699 11.3333 2.00033 8 2.00033Z"
                  fill="#B3C2CB"
                />
              </svg>
            </span>
            <span class="optional"> OPTIONAL </span>
          </h2>
        </div>
      </div>
      <div class="w50 language">
        <b-form-group
            label="Language"
            class="custom-label">
          <vue-bootstrap-typeahead
            id="language"
            ref="language"
            v-model="language"
            no-resize
            :data="$typeAheadAboutsLanguage"
            placeholder="Language here..."
            :serializer="s => `${s.text}`"
            @hit="$event => (language = $event.value)"
          />
        </b-form-group>

        <b-form-group label="Timezone" class="custom-label">
          <vue-bootstrap-typeahead
            id="timezone"
            v-model="timezone"
            no-resize
            :data="$typeAheadAboutsTimezone"
            placeholder="Timezone here..."
            ref="timezone"
            :serializer="s => `${s.text}`"
            @hit="$event => (timezone = $event.value)"
          />
        </b-form-group>
      </div>
      <div v-if="false" class="w50 political">
        <b-form-group
          label="Spiritual"
          label-for="input-6"
          class="custom-label"
        >
          <vue-bootstrap-typeahead
            id="spiritual"
            v-model="spiritual"
            no-resize
            :data="$typeAheadAboutsSpiritual"
            placeholder="Spiritual here..."
            ref="spiritual"
            :serializer="s => `${s.text}`"
            @hit="$event => (spiritual = $event.text)"
          />
        </b-form-group>
        <b-form-group
          label="Political"
          label-for="input-7"
          class="custom-label"
        >
          <vue-bootstrap-typeahead
            id="political"
            v-model="political"
            no-resize
            :data="$typeAheadAboutsPolitical"
            placeholder="Political here..."
            ref="political"
            :serializer="s => `${s.text}`"
            @hit="$event => (political = $event.text)"
          />
        </b-form-group>
      </div>
      <div class="row">
        <div v-if="false" class="col-md-12">
          <h2>
            LOCATION
            <span class="location">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.00001 12.0003C8.3682 12.0003 8.66668 11.7018 8.66668 11.3337C8.66668 10.9655 8.3682 10.667 8.00001 10.667C7.63182 10.667 7.33334 10.9655 7.33334 11.3337C7.33334 11.7018 7.63182 12.0003 8.00001 12.0003Z"
                  fill="#B3C2CB"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.23738 5.70689C7.91366 5.7211 7.74104 5.85135 7.68129 5.97831C7.5245 6.31145 7.12733 6.45441 6.79419 6.29762C6.46106 6.14083 6.3181 5.74366 6.47489 5.41053C6.82301 4.67086 7.57297 4.40144 8.17892 4.37484C8.7618 4.34926 9.48718 4.53492 9.88849 5.05823C10.1973 5.46093 10.3708 5.9714 10.3007 6.50813C10.2297 7.05237 9.91926 7.54056 9.41556 7.91111C8.74294 8.40594 8.74413 8.65841 8.74431 8.69517C8.74431 8.69571 8.74431 8.6962 8.74431 8.69664C8.74431 9.06483 8.44583 9.36331 8.07764 9.36331C7.70945 9.36331 7.41098 9.06483 7.41098 8.69664C7.41098 8.05884 7.78196 7.45763 8.62545 6.8371C8.88471 6.64637 8.96187 6.46388 8.97862 6.33555C8.99635 6.19971 8.95784 6.03573 8.83044 5.8696C8.82148 5.85791 8.77279 5.80928 8.65086 5.76547C8.53445 5.72363 8.38807 5.70028 8.23738 5.70689Z"
                  fill="#B3C2CB"
                />
                <path
                  d="M8 15.3337C3.93334 15.3337 0.666672 12.067 0.666672 8.00033C0.666672 3.93366 3.93334 0.666992 8 0.666992C12.0667 0.666992 15.3333 3.93366 15.3333 8.00033C15.3333 12.067 12.0667 15.3337 8 15.3337ZM8 2.00033C4.66667 2.00033 2.00001 4.66699 2.00001 8.00033C2.00001 11.3337 4.66667 14.0003 8 14.0003C11.3333 14.0003 14 11.3337 14 8.00033C14 4.66699 11.3333 2.00033 8 2.00033Z"
                  fill="#B3C2CB"
                />
              </svg>
            </span>
            <span class="optional"> OPTIONAL </span>
          </h2>
        </div>
        <div v-if="false" class="col-md-12">
          <div class="optional2">
            <div class="toggler " @click="handleToggle">
              <div class="slider" :class="`${shallCaptureLoc ? 'btns' : ''}`" />
            </div>
            <p>
              PonyEngine will be allowed to capture your current location
              <span id="popover-target-1">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.00001 12.0003C8.3682 12.0003 8.66668 11.7018 8.66668 11.3337C8.66668 10.9655 8.3682 10.667 8.00001 10.667C7.63182 10.667 7.33334 10.9655 7.33334 11.3337C7.33334 11.7018 7.63182 12.0003 8.00001 12.0003Z"
                    fill="#B3C2CB"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.23738 5.70689C7.91366 5.7211 7.74104 5.85135 7.68129 5.97831C7.5245 6.31145 7.12733 6.45441 6.79419 6.29762C6.46106 6.14083 6.3181 5.74366 6.47489 5.41053C6.82301 4.67086 7.57297 4.40144 8.17892 4.37484C8.7618 4.34926 9.48718 4.53492 9.88849 5.05823C10.1973 5.46093 10.3708 5.9714 10.3007 6.50813C10.2297 7.05237 9.91926 7.54056 9.41556 7.91111C8.74294 8.40594 8.74413 8.65841 8.74431 8.69517C8.74431 8.69571 8.74431 8.6962 8.74431 8.69664C8.74431 9.06483 8.44583 9.36331 8.07764 9.36331C7.70945 9.36331 7.41098 9.06483 7.41098 8.69664C7.41098 8.05884 7.78196 7.45763 8.62545 6.8371C8.88471 6.64637 8.96187 6.46388 8.97862 6.33555C8.99635 6.19971 8.95784 6.03573 8.83044 5.8696C8.82148 5.85791 8.77279 5.80928 8.65086 5.76547C8.53445 5.72363 8.38807 5.70028 8.23738 5.70689Z"
                    fill="#B3C2CB"
                  />
                  <path
                    d="M8 15.3337C3.93334 15.3337 0.666672 12.067 0.666672 8.00033C0.666672 3.93366 3.93334 0.666992 8 0.666992C12.0667 0.666992 15.3333 3.93366 15.3333 8.00033C15.3333 12.067 12.0667 15.3337 8 15.3337ZM8 2.00033C4.66667 2.00033 2.00001 4.66699 2.00001 8.00033C2.00001 11.3337 4.66667 14.0003 8 14.0003C11.3333 14.0003 14 11.3337 14 8.00033C14 4.66699 11.3333 2.00033 8 2.00033Z"
                    fill="#B3C2CB"
                  />
                </svg>
              </span>
              <b-popover
                target="popover-target-1"
                id="popover-target-2"
                triggers="click"
                placement="bottom"
                class="info_popup"
              >
                (i) Turning on Locations enables PonyEngine to provide
                better services for you, the tool you use and other users. For
                example.Understanding your location helps us provide information
                about medical facilities, clinics, and healthcare providers in
                your area, making it easier for you to access essential
                healthcare services."
              </b-popover>
            </p>
          </div>
        </div>
      </div>
      <div v-if="false" class="row">
        <div class="col-md-12" id="location">
          <div class="group-input">
            <label>Placed Lived</label>
            <b-input-group class="mb-2 place-lived">
              <b-input-group-prepend class="preprend">
                <svg
                  style="justify-self: center"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 11.88 14.12 16.19 12 18.88C9.92 16.21 7 11.85 7 9ZM9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C12.8932 6.5 13.7185 6.9765 14.1651 7.75C14.6116 8.5235 14.6116 9.4765 14.1651 10.25C13.7185 11.0235 12.8932 11.5 12 11.5C10.6193 11.5 9.5 10.3807 9.5 9Z"
                    fill="#B3C2CB"
                  />
                </svg>
              </b-input-group-prepend>
              <b-form-input
                placeholder="Current Location"
                class="input__place-lived"
                v-model="place"
                @keypress.enter.prevent="addPlace"
              ></b-form-input>
              <b-input-group-append>
                <b-input-group-text class="grup-text-end">
                  <svg
                    @click="getLocation"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C6.83 3.52 3.52 6.83 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C17.17 20.48 20.48 17.17 20.94 13H23V11H20.94ZM12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM5 12C5 15.87 8.13 19 12 19C15.87 19 19 15.87 19 12C19 8.13 15.87 5 12 5C8.13 5 5 8.13 5 12Z"
                      fill="#B3C2CB"
                    />
                  </svg>
                </b-input-group-text>
              </b-input-group-append>
            </b-input-group>
            <div class="form-group">
              <div class="places-lived">
                <div
                  class="place__places-lived"
                  v-for="(place, index) in places"
                  :key="index"
                >
                  <span class="ico">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 11.88 14.12 16.19 12 18.88C9.92 16.21 7 11.85 7 9ZM9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C12.8932 6.5 13.7185 6.9765 14.1651 7.75C14.6116 8.5235 14.6116 9.4765 14.1651 10.25C13.7185 11.0235 12.8932 11.5 12 11.5C10.6193 11.5 9.5 10.3807 9.5 9Z"
                        fill="#B3C2CB"
                      />
                    </svg>
                  </span>
                  {{ place }}
                  <span class="ico del__ico" @click="delPlace(place)">
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1 3C1 2.72386 1.22386 2.5 1.5 2.5H10.5C10.7761 2.5 11 2.72386 11 3C11 3.27614 10.7761 3.5 10.5 3.5H1.5C1.22386 3.5 1 3.27614 1 3Z"
                        fill="#FF8C7D"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M5 1.5C4.86739 1.5 4.74022 1.55268 4.64645 1.64645C4.55268 1.74021 4.5 1.86739 4.5 2V2.5H7.5V2C7.5 1.86739 7.44732 1.74021 7.35355 1.64645C7.25979 1.55268 7.13261 1.5 7 1.5H5ZM8.5 2.5V2C8.5 1.60217 8.34196 1.22064 8.06066 0.93934C7.77936 0.658035 7.39782 0.5 7 0.5H5C4.60218 0.5 4.22064 0.658035 3.93934 0.93934C3.65804 1.22064 3.5 1.60217 3.5 2V2.5H2.5C2.22386 2.5 2 2.72386 2 3V10C2 10.3978 2.15804 10.7794 2.43934 11.0607C2.72064 11.342 3.10217 11.5 3.5 11.5H8.5C8.89783 11.5 9.27936 11.342 9.56066 11.0607C9.84196 10.7794 10 10.3978 10 10V3C10 2.72386 9.77614 2.5 9.5 2.5H8.5ZM3 3.5V10C3 10.1326 3.05268 10.2598 3.14645 10.3536C3.24021 10.4473 3.36739 10.5 3.5 10.5H8.5C8.63261 10.5 8.75978 10.4473 8.85355 10.3536C8.94732 10.2598 9 10.1326 9 10V3.5H3Z"
                        fill="#FF8C7D"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M5 5C5.27614 5 5.5 5.22386 5.5 5.5V8.5C5.5 8.77614 5.27614 9 5 9C4.72386 9 4.5 8.77614 4.5 8.5V5.5C4.5 5.22386 4.72386 5 5 5Z"
                        fill="#FF8C7D"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7 5C7.27614 5 7.5 5.22386 7.5 5.5V8.5C7.5 8.77614 7.27614 9 7 9C6.72386 9 6.5 8.77614 6.5 8.5V5.5C6.5 5.22386 6.72386 5 7 5Z"
                        fill="#FF8C7D"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="row">
      <div class="col-md-12">
        <div class="foot">
          <b-button
            variant="primary btn-round-fill"
            type="submit"
            @click.prevent="handleUpdateProfileData"
            >Save Changes
          </b-button
          >
        </div>
      </div>
    </div>
    <Calendar v-if="calendarShow" />
  </b-form>
</template>

<script>

import { required, email } from "vuelidate/lib/validators";
import Vue from "vue";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import TheMask from "vue-the-mask/src/component";
import Calendar from "./profileCalendar/index";
import VueTour from 'vue-tour';
Vue.use(VueTour);
require('vue-tour/dist/vue-tour.css')
export default {
  name: "Me_ProfileInfo",
  components: {
    Calendar,
    VueBootstrapTypeahead,
    TheMask
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.setTypeAheads();
    this.$store.dispatch("user/getProfile");
   // this.$tours['myTour'].start()
  },
  validations: {
    fullName: { required },
    birthdate: { required },
    email: { required, email }
  },
  methods: {
    addPlace(e) {
      this.places.unshift(this.place);
      this.place = "";
    },
    delPlace(place) {
      let index = this.places.indexOf(place);
      if (index > -1) {
        this.places.splice(index, 1);
      }
    },
    onContext(ctx) {
      this.context = ctx;
      let date = ctx.activeFormatted
        .split(",")
        .splice(1, 3)
        .toString()
        .trim();
      // date = date.splice(1, 3).toString().trim();
      this.birthdate = date;
    },
    validationStatus(validation) {
      return typeof validation != "undefined" ? validation.$error : false;
    },
    handleToggle(toggleInput) {
      this.shallCaptureLoc = !this.shallCaptureLoc;
      document.querySelector(".toggler").classList.toggle("bg");
      document.querySelector(".slider").classList.toggle("btns");
    },
    getLocation() {
      console.log("hi");
      {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(this.showPosition);
        } else {
          console.log("Geolocation is not supported by this browser.");
        }
      }
    },
    showPosition(position) {
      this.place = position.coords.latitude + "," + position.coords.longitude;
    },
    showCalender() {
      this.calendarShow = !this.calendarShow;
    },
    handleUpdateProfileData(type) {
      this.$v.$touch();

      if (this.$v.$pending || this.$v.$error) {
        //TODO- Fix later to properly validate- was causing a saving issue earlier with birthdat
        //show error
        //return;
      }

      let name = this.fullName.split(" ");
      let firstname = name[0];
      let lastname =
        name.length > 1
          ? this.fullName.substr(this.fullName.indexOf(" ") + 1)
          : "";

      let dataToUpdate = {
        firstname: firstname,
        lastname: lastname,
        birthdate: this.birthdate,
        phoneNumber: this.phoneNumber,
        mainline: this.mainline,
        shallCaptureLoc: this.shallCaptureLoc ? this.shallCaptureLoc: false ,
        abouts: {
          language: this.language,
          timezone: this.timezone,
          spiritual: this.spiritual,
          political: this.political,
          places: this.places
        },
        force: true
      };

      this.$store.dispatch("user/updateProfile", dataToUpdate).then(res => {

        if (res) {
          this.$store.dispatch("user/getProfile").then(() => {
            this.$store.dispatch("user/showNotification", {
              title: "Changes Saved Successfully",
              description: "Your changes has been saved successfully",
              variant: "success"
            });
          });
        } else {
          this.$store.dispatch("user/showNotification", {
            title: "Ooops! could not save your profile.",
            description: "Your changes were not saved",
            variant: "error"
          });
        }
      });
    },
    setTypeAheads() {
      setTimeout(() => {
        if (
          this.profile &&
          this.profile.abouts &&
          this.profile.abouts.language &&
          this.$refs.language
        ) {
          let languages = this.$typeAheadAboutsLanguage.filter(item => {
            return this.profile.abouts.language == item.value;
          });

          this.$refs.language.$data.inputValue =
            languages.length > 0
              ? languages[0].text
              : this.profile.abouts.language;
        }

        if (
          this.profile &&
          this.profile.abouts &&
          this.profile.abouts.timezone &&
          this.$refs.timezone
        ) {
          let timezones = this.$typeAheadAboutsTimezone.filter(item => {
            return this.profile.abouts.timezone == item.value;
          });
          this.$refs.timezone.$data.inputValue =
            timezones.length > 0
              ? timezones[0].text
              : this.profile.abouts.timezone;
        }

        if (
          this.profile &&
          this.profile.abouts &&
          this.profile.abouts.spiritual &&
          this.$refs.spiritual
        )
          this.$refs.spiritual.$data.inputValue = this.profile.abouts.spiritual;
        if (
          this.profile &&
          this.profile.abouts &&
          this.profile.abouts.political &&
          this.$refs.political
        )
          this.$refs.political.$data.inputValue = this.profile.abouts.political;
      }, 100);
    }
  },
  data() {
    return {
      calendar: false,
      fullName: this.profile
          ? this.profile.firstname + " " + this.profile.lastname
          : null,
      email: this.profile ? this.profile.email : null,
      birthdate:
          this.profile && this.profile.birthdate ? this.profile.birthdate : null,
      phoneNumber:
          this.profile && this.profile.phoneNumber
              ? this.profile.phoneNumber
              : null,
      mainline:
          this.profile && this.profile.mainline ? this.profile.mainline : null,
      language:
          this.profile && this.profile.abouts && this.profile.abouts.language
              ? this.profile.abouts.language
              : null,
      //@ToDo fix the CSS of this. It is currently a hack
      shallCaptureLoc: this.profile && this.profile.shallCaptureLoc !== undefined  ?
          this.profile.shallCaptureLoc : false,
      timezone:
          this.profile && this.profile.abouts && this.profile.abouts.timezone
              ? this.profile.abouts.timezone
              : null,
      spiritual:
          this.profile && this.profile.abouts && this.profile.abouts.spiritual
              ? this.profile.abouts.spiritual
              : null,
      political:
          this.profile && this.profile.abouts && this.profile.abouts.political
              ? this.profile.abouts.political
              : null,
      location: "",
      calendarShow: false,
      value: "",
      context: null,
      place: "",
      places:
          this.profile && this.profile.abouts && this.profile.abouts.places
              ? this.profile.abouts.places
              : [],
      steps: [
        {
          target: '#v-step-0',  // We're using document.querySelector() under the hood
          content: `Discover <strong>Vue Tour</strong>!`
        },
        {
          target: '.v-step-1',
          content: 'An awesome plugin made with Vue.js!'
        },
        {
          target: '[data-v-step="2"]',
          content: 'Try it, you\'ll love it!<br>You can put HTML in the steps and completely customize the DOM to suit your needs.',
          params: {
            placement: 'top'
          }
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  // background:#000 ;
}
.invalid-feedback {
  font-size: 14px;
  margin-left: 10px;
  font-family: "Nunito";
}
.form {
  margin-top: 32px;
  font-family: "Nunito", sans-serif;
  .w50 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 24px;
    margin-bottom: 16px;
    position: relative;
    @media (max-width: 650px) {
      grid-template-columns: 1fr;
      row-gap: 24px;
    }

    #icon {
      position: relative;
      span {
        position: absolute;
        position: absolute;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 5%;
      }
    }
    .select-custom {
      user-select: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      background: transparent;
      background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
      background-repeat: no-repeat;
      background-position-x: 98%;
      background-position-y: 50%;
      position: relative;
      cursor: pointer;
      .custom_dropdown {
        list-style: none;
        font-family: "Nunito", sans-serif;
        font-weight: 600;
        font-style: normal;
        position: absolute;
        background-color: #fff;
        z-index: 99;
        // margin-top: -13px;
        width: 100%;
        left: 0;
        border-radius: 0 0 12px 12px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-direction: column;
        height: 80px;
        // transform: translateY(10px);
        transition: 0.4s linear;
        cursor: pointer !important;
        padding: 0px 16px;

        box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.08);
        li {
          width: 100%;
          height: 100%;
          display: flex;
          // justify-content: center;

          align-items: center;
          border-radius: 8px;
          transition: 0.4s linear;
          &:hover span {
            color: var(--theme-color);
          }

          span {
            color: #474d52;
            text-decoration: none;
            transition: 0.4s linear;
            pointer-events: none;
            &:hover {
              color: #fff;
            }
          }
        }
      }
      .myButton {
        border: none;
        outline: none;
        background: none;
        height: 100%;
        display: flex;
        align-items: center;
      }
      // padding-top: 0;
    }
  }
  .political .language .timezone{
    @media (max-width: 650px) {
      margin-bottom: 24px !important;
    }
  }

  #location {
    position: relative;
    .preappend-icon,
    .append-icon {
      position: absolute;
      top: 48%;
    }
    .preappend-icon {
      left: 3%;
    }
    .append-icon {
      right: 5%;
    }
    .custom-input {
      padding-left: 50px;
    }
  }
  .custom-label {
    font-weight: 600;
    font-size: 14px;
    color: #a1b1ba;
    margin-bottom: 8px;
  }

  .custom-input {
    background: #ffffff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 100px;
    border: none;
    outline: none;
    padding: 0 21px;
    height: 48px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: #474d52;
    &:focus {
      border: none;
      outline: none;
    }
    &::placeholder {
      font-weight: normal;
      font-size: 16px;
      color: #a1b1ba;
      margin-bottom: 8px;
      font-family: "Nunito", sans-serif;
    }
    &.active {
      border-radius: 20px 20px 0 0;
    }
  }
  h2 {
    font-weight: 600;
    font-size: 14px;
    display: flex;
    align-items: center;
    letter-spacing: 0.05em;
    color: #474d52;
    // margin-top: 27px;
    margin-bottom: 24px;
    @media (max-width: 650px) {
      &.specific {
        margin-top: 20px;
      }
    }
    span {
      padding-left: 4px;
      padding-bottom: 4px;
    }
    .optional {
      font-size: 12px;

      color: #8d99a0;
      padding-left: 8px;
    }
  }
  .specific {
    margin-top: 20px;
  }

  .location {
    opacity: 0;
  }
  .optional2 {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
    p {
      margin-left: 16px;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      display: flex;
      align-items: center;
      color: #474d52;
      margin: 0;
      margin-left: 16px;

      span {
        padding-left: 8px;
      }
    }
  }
  .input-group-text {
    border-right: none;
    background-color: #ffffff;
    border: none !important;
    cursor: pointer;
  }
  .btn-round-fill {
    width: 166px;
    height: 40px;
    margin-top: 24px;
    margin-bottom: 24px;
    margin-bottom: 80px;
  }
  .foot {
    border-top: 1px solid #ddd;
    margin-top: 32px;
  }
}
.toggler {
  position: relative;
  display: inline-block;
  width: 46.5px;
  height: 24px;
  background: #f3f6f9;
  border-radius: 18px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  cursor: pointer;
  @media (max-width: 590px) {
    margin-left: 15px;
  }
}
.slider {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: #b3c2cb;
  box-shadow: 0px 3px 9px #c4c4c4;

  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}
.bg {
  background: rgba(85, 126, 251, 0.1);
}
.btns {
  left: 50%;
  background: var(--theme-color);
  box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
}
#popover-target-1 {
  cursor: pointer;
}
.place-lived {
  height: 47px;
  background: #ffffff;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 100px;
  display: grid;
  grid-template-columns: 50px 1fr 50px;
  align-items: center;
  justify-content: center;
  .preprend {
    justify-content: center;
  }
  .input__place-lived {
    width: 100%;
    border: none;
    &:focus {
      box-shadow: none;
    }
  }
}
.places-lived {
  margin-top: 26px;
  .place__places-lived {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #474d52;
    margin: 6px 0;
  }
  .del__ico {
    cursor: pointer;
  }
}
.birthday_input {
  position: relative;
}
.birthday-calendar_wrapper {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1;
}
</style>
